import type { ConvertableUnit } from "@/libs/units";
import { buildOptions } from "./buildOptions";

export const Hertz: ConvertableUnit = {
  label: "Hz",
  toStandardUnit: hz => hz,
  toThisUnit: hz => hz
};

const unitList = [Hertz];
export const FrequencyUnits = {
  Hertz,
  options: buildOptions(unitList)
};
